import React from 'react';
import { Facebook, Instagram, Mail, MapPin, Phone } from 'lucide-react';
import { Separator } from './ui/Separator';
export function Footer() {
  return <footer className="w-full bg-[#050505] text-white pt-20 pb-8" data-id="element-35">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-36">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-8 mb-16" data-id="element-37">
          {/* Column 1: Brand */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-38">
            <div className="mb-6" data-id="element-39">
              <img src="https://cdn.magicpatterns.com/uploads/f8cy29DHmDei39Mx1pqc62/Love_Outdoor_Light_Logo_New.png" alt="Love Outdoor Lighting" className="h-16 w-auto object-contain sm:h-20" data-id="element-40" />
            </div>
            <p className="text-gray-400 mb-8 max-w-xs" data-id="element-41">
              Premium Outdoor & Landscape Lighting — Installation | Design |
              Maintenance
            </p>
            <div className="flex gap-4" data-id="element-42">
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[var(--brand-gold)] hover:text-black transition-colors" data-id="element-43">
                <Facebook className="w-5 h-5" data-id="element-44" />
                <span className="sr-only" data-id="element-45">Facebook</span>
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[var(--brand-gold)] hover:text-black transition-colors" data-id="element-46">
                <Instagram className="w-5 h-5" data-id="element-47" />
                <span className="sr-only" data-id="element-48">Instagram</span>
              </a>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-49">
            <h3 className="text-lg font-bold uppercase tracking-wider mb-6 text-[var(--brand-gold)]" data-id="element-50">
              Quick Links
            </h3>
            <ul className="space-y-4" data-id="element-51">
              {['Home', 'Services', 'Projects', 'Service Areas', 'Blog', 'Contact'].map(link => <li key={link} data-id="element-52">
                  <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-53">
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Column 3: Contact */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-54">
            <h3 className="text-lg font-bold uppercase tracking-wider mb-6 text-[var(--brand-gold)]" data-id="element-55">
              Contact Us
            </h3>
            <ul className="space-y-6" data-id="element-56">
              <li className="flex items-start gap-4" data-id="element-57">
                <Phone className="w-6 h-6 text-[var(--brand-gold)] flex-shrink-0" data-id="element-58" />
                <a href="tel:480-270-2014" className="text-gray-400 hover:text-white transition-colors" data-id="element-59">
                  480-270-2014
                </a>
              </li>
              <li className="flex items-start gap-4" data-id="element-60">
                <Mail className="w-6 h-6 text-[var(--brand-gold)] flex-shrink-0" data-id="element-61" />
                <a href="mailto:hello@loveoutdoorlighting.com" className="text-gray-400 hover:text-white transition-colors" data-id="element-62">
                  hello@loveoutdoorlighting.com
                </a>
              </li>
              <li className="flex items-start gap-4" data-id="element-63">
                <MapPin className="w-6 h-6 text-[var(--brand-gold)] flex-shrink-0" data-id="element-64" />
                <span className="text-gray-400" data-id="element-65">
                  Chandler, AZ
                  <br data-id="element-66" />
                  Serving all of greater Phoenix
                </span>
              </li>
            </ul>
          </div>
        </div>

        <Separator className="bg-white/10 mb-8" data-id="element-67" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500" data-id="element-68">
          <p data-id="element-69">© 2025 Love Outdoor Lighting. All rights reserved.</p>
          <p data-id="element-70">Website by LetLois</p>
        </div>
      </div>
    </footer>;
}